import { render, staticRenderFns } from "./TournamentsAdvanced.vue?vue&type=template&id=2e37b06c&scoped=true"
import script from "./TournamentsAdvanced.vue?vue&type=script&lang=js"
export * from "./TournamentsAdvanced.vue?vue&type=script&lang=js"
import style0 from "./TournamentsAdvanced.vue?vue&type=style&index=0&id=2e37b06c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37b06c",
  null
  
)

export default component.exports